import {IconProps} from './types';

const CarouselChevron = ({fill, className}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="26"
        fill="none"
        viewBox="0 0 11 18"
        className={className}
    >
        <path
            d="M9 2L2 9l7 7"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CarouselChevron;
